import { Badge, Tooltip } from '@radix-ui/themes';
import { ClickToCopy } from '@hubertai/hubert-component-library';

type ExternalJobRefProps = {
  externalId?: string;
  source?: string;
};

const externalJobRefSources: Record<string, string> = {
  BULLHORN_NOVO: 'Bullhorn',
  BULLHORN_RECRUITMENT_CLOUD: 'Bullhorn',
  PUBLIC_API: 'Hubert Public API',
};

const getExternalJobRefTooltipContent = (source: string | null) => {
  const sourceName = source ? (externalJobRefSources[source] ?? null) : null;
  return <span>Job reference ID from your {sourceName ? `${sourceName} integration` : 'integration account'}.</span>;
};

const ExternalJobRef = (props: ExternalJobRefProps) => {
  if (!props.externalId) {
    return <span> - </span>;
  }

  return (
    <div>
      <ClickToCopy
        copyText={props.externalId ?? ''}
        variant="ghost"
        accessibility={{
          successMessage: 'External reference copied to clipboard.',
          errorMessage: 'Failed to copy external reference.',
          copyActionLabel: 'Copy external reference',
          copyButtonLabel: 'Copy external reference using icon button',
        }}
      >
        <Tooltip content={getExternalJobRefTooltipContent(props.source ?? null)}>
          <Badge radius="small" color="gray">
            <span style={{ fontFamily: 'monospace' }}>{props.externalId}</span>
          </Badge>
        </Tooltip>
      </ClickToCopy>
    </div>
  );
};

export default ExternalJobRef;
